import styled from 'styled-components';
import {mobileMedia} from '../../globalVariables/GlobalVariables';

export const bar = styled.div`
    display: flex;
    align-items: center;
    gap: var(--space-md);
    width: 100%;
    height: 64px;
    box-sizing: border-box;
    padding: var(--space-md) var(--space-lg);
    background: var(--TA-color-bg-base);
    border: 1px solid var(--color-border-subtle);
    border-radius: var(--radius-md);
`;

export const searchPill = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: var(--space-sm);
    width: 268px;
    height: 32px;
    padding: 0 var(--space-lg);
    background: var(--TA-color-bg-surface-default);
    border-radius: var(--radius-full);
    color: var(--TA-color-text-default);
    font-size: var(--font-size-button-category);

    ${mobileMedia} {
        width: 100%;
    }
`;

export const searchInput = styled.input`
    flex: 1;
    min-width: 0;
    height: 100%;
    border: none;
    background: transparent;
    outline: none;
    color: inherit;
    font: inherit;
    text-align: inherit;
    padding: 0;

    &::placeholder {
        color: var(--TA-color-text-default);
    }
`;
